import Vue from 'vue'
import moment from 'moment'
import store from '@/vuex/store'

Vue.filter('simNao', valor => valor === true ? 'Sim' : 'Não')

Vue.filter('cpfMask', cpf => {
    if(cpf && cpf.length < 14) {
        return cpf.slice(0, 3) + '.' + cpf.slice(3, 6) + '.' + cpf.slice(6, 9) + '-' + cpf.slice(9)
    } else {
        return cpf
    }
})

Vue.filter('monetarioMask', valor => {
    if (valor) {
        let str = valor.toString();
        if(!str.match(/[,.]/)) {  // Exemplo 3000
            str = str + '00'
        }
        if(str.charAt(str.length-2) == '.') {  // Exemplo 3000.0
            str = str + '0'
        }
        if(str.match(/[,.]/)) {  // Exemplo 3000.00
            str = str.replace(/[\D]+/g,'')
        }
        let formatado = str.replace(/([0-9]{2})$/g, ",$1")
        if(formatado.length > 9) {
            return formatado.replace(/([0-9]{3})([0-9]{3}),([0-9]{2})$/g, ".$1.$2,$3")
        }
        if(formatado.length > 6) {
            return formatado.replace(/([0-9]{3}),([0-9]{2})$/g, ".$1,$2")
        } else {
            return formatado
        }
    }
})

Vue.filter('formataData', valor => {
    if (valor) {
      return moment(String(valor)).format('DD/MM/YYYY')
    }
})

Vue.filter('grauParentescoFilter', valor => {
    if (valor) {
        let graus = store.state.graus
        let grau = graus.find(grau => grau.name == valor)
        return grau ? grau.displayName.toUpperCase() : 'Não encontrado'
    }
})

Vue.filter('formataRegistro', valor => {
    if (!!valor) {
        let str = valor.toString()
        return str.replace(/([0-9]{2})([0-9]{3})([0-9]{1})/, '$1.$2-$3')
    }
})

Vue.filter('formataCep', valor => {
    if(!!valor) {
        let str = valor.toString()
        return str.replace(/([0-9]{2})([0-9]{3})([0-9]{3})/, '$1.$2-$3')
    }
})

Vue.filter('tudoMaiusculo', valor => {
    if (!!valor) {
        return valor.toUpperCase()
    }
})


// WEBPACK FOOTER //
// ./src/filters/filters.js